module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Medium-3a4f1d525cbb8b808873b7cabf23a2c2.woff2";